<!-- Property of OSF Global Services, Inc., (with its brand OSF Commerce). OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->
<style scoped>
.row {
    width: 100%;
    overflow: hidden;
    display: block;
    margin: 0;
}

.tabs {
    background-color: #5f4c54;
}

.tabs .tabs__icon {
    color: #ffffff;
}

.tick {
    text-align: right;
    font-size: 28pt;
    color: black;
    font-weight: bold;
    width: 20%;
}

.tick-answered {
    opacity: 1;
}

.tick-notanswered {
    opacity: 0.33;
}

.accordion-title-left {
    width: 20%;
}

.accordion-title-left > .orderNumber {
    text-align: center;
    border-radius: 50%;
    width: 2.25rem;
    height: 2.25rem;
    line-height: 2.25rem;
    color: black;
    font-size: 1.5rem;
    font-family: Arial, sans-serif;
}

.accordion-title-left > .accordion-question-label {
    font-size: 1.2em;
    font-weight: 500;
}

.accordion-title-and-answer {
    text-align: center;
}

.accordion-title-and-answer h2 {
    font-size: 1.5em;
    font-weight: 500;
}
</style>

<template>
    <div>
        <!-- Directional Type Head -->
        <div v-if="quizData.type == 'directional'">
            <div v-if="quizData.renderingType == 'accordion'">
                <accordion>
                    <accordion-item
                        v-for="item in this.stepData.titles"
                        v-bind:key="item.id"
                        :item="item"
                        :clickable="item.current || item.answered"
                    >
                        <!-- This slot will handle the title/header of the accordion and is the part you click on -->
                        <template slot="accordion-trigger">
                            <div class="accordion-title-left">
                                <div class="orderNumber">
                                    {{ item.orderNr }}
                                </div>
                                <h3 v-show="quizData.showStepTitle" class="accordion-question-label">
                                    {{ item.title }}
                                </h3>
                            </div>
                            <div class="accordion-title-and-answer">
                                <h2 v-if="!item.current">
                                    {{ item.questionString }}
                                </h2>
                                <button
                                    v-for="(answer, index) of item.answersTitles"
                                    :key="index"
                                    class="mx-2 btn btn btn-light btn-sm"
                                    aria-pressed="true"
                                    color="green"
                                    text-color="white"
                                    :name="'answer' + index"
                                >
                                    {{ answer }}
                                </button>
                            </div>
                            <span v-bind:class="['tick', item.answered ? 'tick-answered' : 'tick-notanswered']">✓</span>
                        </template>
                        <!-- This slot will handle all the content that is passed to the accordion -->
                        <template slot="accordion-content">
                            <QuestionBody v-if="item.current" v-bind:question="question" />
                        </template>
                    </accordion-item>
                </accordion>
            </div>

            <div v-else-if="quizData.renderingType == 'legacy'">
                <QuestionBody v-bind:question="question" />
                <!-- Progress Bar -->
                <div v-show="quizData.showProgressBar" class="row">
                    <div class="stepIndicator progress">
                        {{ this.quizData.translations.step }}&nbsp;{{ this.stepData.currentIndex }}/{{
                            this.stepData.total
                        }}
                    </div>
                </div>

                <StepsBarComponent />
            </div>
        </div>

        <!-- Guided Type Head -->
        <div v-else-if="quizData.type == 'guided'">
            <div v-show="quizData.showStepTitle" class="row">
                <!-- Step indicator for guided -->
                <div class="stepIndicator">
                    {{ this.question.stepTitle }}
                </div>
            </div>
            <QuestionBody v-bind:question="question" />
        </div>

        <!-- Counting Type Head -->
        <div v-else-if="quizData.type == 'counting'">
            <div v-show="quizData.showStepTitle" class="row">
                <!-- Step indicator for guided -->
                <div class="stepIndicator">
                    {{ this.question.stepTitle }}
                </div>
            </div>
            <QuestionBody v-bind:question="question" />
        </div>

        <!-- Reactive Type Head -->
        <div v-else-if="quizData.type == 'reactive'">
            <div v-if="quizData.renderingType == 'accordion'">
                <accordion>
                    <accordion-item
                        v-for="item in this.stepData.titles"
                        v-bind:key="item.id"
                        :item="item"
                        :clickable="item.current || item.answered"
                    >
                        <!-- This slot will handle the title/header of the accordion and is the part you click on -->
                        <template slot="accordion-trigger">
                            <div class="accordion-title-left">
                                <div class="orderNumber">
                                    {{ item.orderNr }}
                                </div>
                                <h3 v-show="quizData.showStepTitle" class="accordion-question-label">
                                    {{ item.title }}
                                </h3>
                            </div>
                            <div class="accordion-title-and-answer">
                                <h2 v-if="!item.current">
                                    {{ item.questionString }}
                                </h2>
                                <button
                                    v-for="(answer, index) of item.answersTitles"
                                    :key="index"
                                    class="mx-2 btn btn btn-light btn-sm"
                                    aria-pressed="true"
                                    color="green"
                                    text-color="white"
                                    :name="'answer' + index"
                                >
                                    {{ answer }}
                                </button>
                            </div>
                            <span v-bind:class="['tick', item.answered ? 'tick-answered' : 'tick-notanswered']">✓</span>
                        </template>
                        <!-- This slot will handle all the content that is passed to the accordion -->
                        <template slot="accordion-content">
                            <QuestionBody v-if="item.current" v-bind:question="question" />
                        </template>
                    </accordion-item>
                </accordion>
            </div>
            <div v-else-if="quizData.renderingType == 'legacy'">
                <!-- Progress Bar -->
                <div v-show="quizData.showProgressBar" class="row">
                    <div class="stepIndicator progress">
                        {{ this.quizData.translations.step }}&nbsp;{{ this.stepData.currentIndex }}/{{
                            this.stepData.total
                        }}
                    </div>
                </div>

                <!-- Steps bar for directional -->
                <div v-show="quizData.showStepTitle" class="row">
                    <ul class="quizTopCTAs">
                        <li
                            v-for="item in this.stepData.titles"
                            v-bind:key="item.id"
                            v-bind:id="item.id"
                            v-bind:class="[
                                item.id,
                                'stepIndicator',
                                item.current ? 'active' : '',
                                item.answered ? 'answered' : 'unanswered',
                                !quizData.navBtns && item.answered ? 'answereddisabled' : '',
                            ]"
                            v-bind:disabled="!item.answered"
                        >
                            {{ item.title }}
                        </li>
                    </ul>
                </div>
                <QuestionBody v-bind:question="question" />
            </div>
        </div>
    </div>
</template>

<script>
import Accordion from "./accordion/accordionComponent.vue";
import AccordionItem from "./accordion/accordionItemComponent.vue";
import QuestionBody from "./questionBodyComponent.vue";
import StepsBarComponent from "./stepsBarComponent.vue";

export default {
    name: "Question",
    components: {
        Accordion,
        AccordionItem,
        QuestionBody,
        StepsBarComponent,
    },
    computed: {
        quizData: function () {
            return this.$store.state.quizData;
        },
        question: function () {
            return this.$store.state.questionData;
        },
        stepData: function () {
            return this.$store.state.stepData;
        },
        error: function () {
            return this.$store.state.errorShow;
        },
    },
    methods: {
        gotoQuestion: function (id, current, answered) {
            const isLastQuestion = this.stepData.titles.length === this.stepData.currentIndex;
            if ((!current && answered && this.quizData.navBtns) || isLastQuestion) {
                this.$store.dispatch("gotoQuestion", id);
            }
        },
    },
};
</script>
